import { useState, useEffect } from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import { FaPlus, FaMinus } from 'react-icons/fa';
import * as S from './styled';
import Layout from '../../data/Layout';
import { InputDefault } from '../../data/inputDefault';
import ReactSelect from '../../data/reactSelect';
import { useAppSelector } from '../../../redux/store';
import { IFormEmitirNfe, INfeCliente, INfeProduto, INfePedido, INfeRequest, INfeResponse } from '../../../interfaces/INfe';
import { useEmitirNfe } from '../../../apiQuery/useEmitirNfe';
import { notifyError } from '../../notify/notify-component';
import NfeSuccessModal from './NfeSuccessModal';

export default function FormEmitirNfe({ title, onCancel }: IFormEmitirNfe) {
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);
  const emitirNfe = useEmitirNfe();

  // Estados do cliente
  const [cpf, setCpf] = useState<string>('056.839.710-04');
  const [nomeCompleto, setNomeCompleto] = useState<string>('Nome do Cliente');
  const [endereco, setEndereco] = useState<string>('Av. Brg. Faria Lima');
  const [complemento, setComplemento] = useState<string>('Escritório');
  const [numero, setNumero] = useState<string>('1000');
  const [bairro, setBairro] = useState<string>('Itaim Bibi');
  const [cidade, setCidade] = useState<string>('São Paulo');
  const [uf, setUf] = useState<string>('SP');
  const [cep, setCep] = useState<string>('00000-000');
  const [telefone, setTelefone] = useState<string>('(00) 0000-0000');
  const [email, setEmail] = useState<string>('nome@email.com');

  // Estados da NFe
  const [operacao, setOperacao] = useState<number>(1);
  const [naturezaOperacao, setNaturezaOperacao] = useState<string>('Venda de produção do estabelecimento');
  const [modelo, setModelo] = useState<number>(1);
  const [finalidade, setFinalidade] = useState<number>(1);
  const [ambiente, setAmbiente] = useState<number>(2);

  // Estados do pedido
  const [pagamento, setPagamento] = useState<number>(0);
  const [presenca, setPresenca] = useState<number>(2);
  const [modalidadeFrete, setModalidadeFrete] = useState<number>(0);
  const [frete, setFrete] = useState<string>('12.56');
  const [desconto, setDesconto] = useState<string>('10.00');
  const [total, setTotal] = useState<string>('174.60');

  // Estados dos produtos
  const [produtos, setProdutos] = useState<INfeProduto[]>([
    {
      nome: 'Nome do produto',
      codigo: 'nome-do-produto',
      ncm: '6109.10.00',
      cest: '28.038.00',
      quantidade: 3,
      unidade: 'UN',
      peso: '0.800',
      origem: 0,
      subtotal: '4.90',
      total: '13.70',
      classe_imposto: 'REF17302684'
    },
    {
      nome: 'Nome do produto',
      codigo: 'nome-do-produto',
      ncm: '6109.10.00',
      cest: '28.038.00',
      quantidade: 1,
      unidade: 'UN',
      peso: '0.800',
      origem: 0,
      subtotal: '29.90',
      total: '29.90',
      classe_imposto: 'REF17302684'
    }
  ]);

  // Estados adicionais para o modal
  const [showSuccessModal, setShowSuccessModal] = useState<boolean>(false);
  const [nfeResponse, setNfeResponse] = useState<INfeResponse | null>(null);

  // Validações
  const [validCpf, setValidCpf] = useState<boolean>(false);
  const [validNome, setValidNome] = useState<boolean>(false);
  const [validEndereco, setValidEndereco] = useState<boolean>(false);
  const [validNumero, setValidNumero] = useState<boolean>(false);
  const [validBairro, setValidBairro] = useState<boolean>(false);
  const [validCidade, setValidCidade] = useState<boolean>(false);
  const [validUf, setValidUf] = useState<boolean>(false);
  const [validCep, setValidCep] = useState<boolean>(false);

  // Opções para selects
  const operacaoOptions = [
    { value: 1, label: 'Saída' },
    { value: 0, label: 'Entrada' }
  ];

  const ambienteOptions = [
    { value: 1, label: 'Produção' },
    { value: 2, label: 'Homologação' }
  ];

  const finalidadeOptions = [
    { value: 1, label: 'Normal' },
    { value: 2, label: 'Complementar' },
    { value: 3, label: 'Ajuste' },
    { value: 4, label: 'Devolução' }
  ];

  const pagamentoOptions = [
    { value: 0, label: 'À vista' },
    { value: 1, label: 'À prazo' },
    { value: 2, label: 'Outros' }
  ];

  const presencaOptions = [
    { value: 0, label: 'Não se aplica' },
    { value: 1, label: 'Operação presencial' },
    { value: 2, label: 'Operação não presencial, pela Internet' },
    { value: 3, label: 'Operação não presencial, Teleatendimento' },
    { value: 4, label: 'NFC-e em operação com entrega a domicílio' },
    { value: 9, label: 'Operação não presencial, outros' }
  ];

  const modalidadeFreteOptions = [
    { value: 0, label: 'Por conta do emitente' },
    { value: 1, label: 'Por conta do destinatário' },
    { value: 2, label: 'Por conta de terceiros' },
    { value: 3, label: 'Transporte próprio por conta do remetente' },
    { value: 4, label: 'Transporte próprio por conta do destinatário' },
    { value: 9, label: 'Sem ocorrência de transporte' }
  ];

  const unidadeOptions = [
    { value: 'UN', label: 'Unidade' },
    { value: 'KG', label: 'Quilograma' },
    { value: 'LT', label: 'Litro' },
    { value: 'MT', label: 'Metro' },
    { value: 'M2', label: 'Metro Quadrado' },
    { value: 'M3', label: 'Metro Cúbico' }
  ];

  const adicionarProduto = () => {
    setProdutos([...produtos, {
      nome: '',
      codigo: '',
      ncm: '',
      cest: '',
      quantidade: 1,
      unidade: 'UN',
      peso: '0.000',
      origem: 0,
      subtotal: '0.00',
      total: '0.00',
      classe_imposto: ''
    }]);
  };

  const removerProduto = (index: number) => {
    if (produtos.length > 1) {
      const novosProdutos = produtos.filter((_, i) => i !== index);
      setProdutos(novosProdutos);
    }
  };

  const atualizarProduto = (index: number, campo: keyof INfeProduto, valor: string | number) => {
    const novosProdutos = [...produtos];
    novosProdutos[index] = { ...novosProdutos[index], [campo]: valor };
    
    // Recalcula o total do produto se quantidade ou subtotal mudaram
    if (campo === 'quantidade' || campo === 'subtotal') {
      const quantidade = parseFloat(novosProdutos[index].quantidade.toString()) || 0;
      const subtotal = parseFloat(novosProdutos[index].subtotal) || 0;
      novosProdutos[index].total = (quantidade * subtotal).toFixed(2);
    }
    
    setProdutos(novosProdutos);
  };

  const calcularTotal = (produtosList: INfeProduto[]) => {
    const totalProdutos = produtosList.reduce((acc, produto) => {
      return acc + (parseFloat(produto.total) || 0);
    }, 0);
    
    const freteValue = parseFloat(frete) || 0;
    const descontoValue = parseFloat(desconto) || 0;
    const totalFinal = totalProdutos + freteValue - descontoValue;
    
    setTotal(totalFinal.toFixed(2));
  };

  // Comentado para manter o total fixo de 174.60 conforme payload de teste
  // useEffect(() => {
  //   calcularTotal(produtos);
  // }, [produtos, frete, desconto]);

  const handleValidate = () => {
    let isValid = true;

    // Validar cliente
    if (!cpf) { setValidCpf(true); isValid = false; } else setValidCpf(false);
    if (!nomeCompleto) { setValidNome(true); isValid = false; } else setValidNome(false);
    if (!endereco) { setValidEndereco(true); isValid = false; } else setValidEndereco(false);
    if (!numero) { setValidNumero(true); isValid = false; } else setValidNumero(false);
    if (!bairro) { setValidBairro(true); isValid = false; } else setValidBairro(false);
    if (!cidade) { setValidCidade(true); isValid = false; } else setValidCidade(false);
    if (!uf) { setValidUf(true); isValid = false; } else setValidUf(false);
    if (!cep) { setValidCep(true); isValid = false; } else setValidCep(false);

    // Validar produtos
    const produtosValidos = produtos.every(produto => 
      produto.nome && produto.codigo && produto.ncm && produto.classe_imposto
    );

    if (!produtosValidos) {
      notifyError('Todos os produtos devem ter nome, código, NCM e classe de imposto preenchidos.');
      isValid = false;
    }

    return isValid;
  };

  const handleSubmit = async () => {
    // Previne múltiplas submissões
    if (emitirNfe.isPending) {
      return;
    }

    if (!handleValidate()) {
      notifyError('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    const cliente: INfeCliente = {
      cpf,
      nome_completo: nomeCompleto,
      endereco,
      complemento,
      numero: parseInt(numero),
      bairro,
      cidade,
      uf,
      cep,
      telefone,
      email
    };

    const pedido: INfePedido = {
      pagamento,
      presenca,
      modalidade_frete: modalidadeFrete,
      frete,
      desconto,
      total
    };

    const nfeData: INfeRequest = {
      operacao,
      natureza_operacao: naturezaOperacao,
      modelo,
      finalidade,
      ambiente,
      store_id: storeMe?.storeActive?.id || 0,
      cliente,
      produtos,
      pedido
    };

    emitirNfe.mutate(nfeData, {
      onSuccess: (data) => {
        setNfeResponse(data);
        setShowSuccessModal(true);
      },
      onError: (error) => {
        // Cria uma resposta de erro personalizada para exibir no modal
        const errorResponse: INfeResponse = {
          uuid: 'error-' + Date.now(),
          status: 400,
          body: {
            uuid: '',
            status: 'error',
            motivo: '',
            nfe: '',
            serie: '',
            chave: '',
            modelo: '',
            epec: false,
            xml: '',
            danfe: '',
            danfe_simples: '',
            danfe_etiqueta: '',
            log: {} as any,
            error: error.message
          }
        };
        setNfeResponse(errorResponse);
        setShowSuccessModal(true);
      }
    });
  };

  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
    setNfeResponse(null);
    // Só fecha o formulário se não houve erro
    if (nfeResponse && !nfeResponse.body.error) {
      onCancel();
    }
  };

  return (
    <Layout
      title={title}
      isEditable={false}
      onClickSave={handleSubmit}
      onClickEdit={handleSubmit}
      onClickCancel={onCancel}
      loading={emitirNfe.isPending}
    >
      <S.Wrapper>
        <Row className="mb-4">
          <Col>
            <h4>Dados da Nota Fiscal</h4>
          </Col>
        </Row>

        <S.FormSection>
          <ReactSelect
            label="Operação"
            placeholder="Tipo de operação"
            options={operacaoOptions}
            state={operacao}
            setState={setOperacao}
          />

          <InputDefault
            label="Natureza da Operação"
            type="text"
            state={naturezaOperacao}
            setState={setNaturezaOperacao}
            placeholder="Ex: Venda de produção do estabelecimento"
          />

          <ReactSelect
            label="Finalidade"
            placeholder="Finalidade da NFe"
            options={finalidadeOptions}
            state={finalidade}
            setState={setFinalidade}
          />

          <ReactSelect
            label="Ambiente"
            placeholder="Ambiente de emissão"
            options={ambienteOptions}
            state={ambiente}
            setState={setAmbiente}
          />
        </S.FormSection>

        <Row className="mb-4 mt-4">
          <Col>
            <h4>Dados do Cliente</h4>
          </Col>
        </Row>

        <S.FormSection>
          <InputDefault
            label="CPF/CNPJ"
            type="text"
            state={cpf}
            setState={setCpf}
            placeholder="000.000.000-00"
            isInvalid={validCpf}
          />

          <InputDefault
            label="Nome Completo"
            type="text"
            state={nomeCompleto}
            setState={setNomeCompleto}
            placeholder="Nome do cliente"
            isInvalid={validNome}
          />

          <InputDefault
            label="Email"
            type="email"
            state={email}
            setState={setEmail}
            placeholder="cliente@email.com"
          />
        </S.FormSection>

        <S.FormSection>
          <InputDefault
            label="Endereço"
            type="text"
            state={endereco}
            setState={setEndereco}
            placeholder="Rua, avenida..."
            isInvalid={validEndereco}
          />

          <InputDefault
            label="Número"
            type="text"
            state={numero}
            setState={setNumero}
            placeholder="123"
            isInvalid={validNumero}
          />

          <InputDefault
            label="Complemento"
            type="text"
            state={complemento}
            setState={setComplemento}
            placeholder="Apt, sala..."
          />
        </S.FormSection>

        <S.FormSection>
          <InputDefault
            label="Bairro"
            type="text"
            state={bairro}
            setState={setBairro}
            placeholder="Nome do bairro"
            isInvalid={validBairro}
          />

          <InputDefault
            label="Cidade"
            type="text"
            state={cidade}
            setState={setCidade}
            placeholder="Nome da cidade"
            isInvalid={validCidade}
          />

          <InputDefault
            label="UF"
            type="text"
            state={uf}
            setState={setUf}
            placeholder="SP"
            maxLength={2}
            isInvalid={validUf}
          />

          <InputDefault
            label="CEP"
            type="text"
            state={cep}
            setState={setCep}
            placeholder="00000-000"
            isInvalid={validCep}
          />
        </S.FormSection>

        <S.FormSection>
          <InputDefault
            label="Telefone"
            type="text"
            state={telefone}
            setState={setTelefone}
            placeholder="(00) 0000-0000"
          />
        </S.FormSection>

        <Row className="mb-4 mt-4">
          <Col className="d-flex justify-content-between align-items-center">
            <h4>Produtos</h4>
            <Button variant="success" size="sm" onClick={adicionarProduto}>
              <FaPlus /> Adicionar Produto
            </Button>
          </Col>
        </Row>

        {produtos.map((produto, index) => (
          <S.ProductSection key={index}>
            <Row className="mb-2">
              <Col className="d-flex justify-content-between align-items-center">
                <h5>Produto {index + 1}</h5>
                {produtos.length > 1 && (
                  <Button 
                    variant="danger" 
                    size="sm" 
                    onClick={() => removerProduto(index)}
                  >
                    <FaMinus /> Remover
                  </Button>
                )}
              </Col>
            </Row>

            <S.FormSection>
              <InputDefault
                label="Nome do Produto"
                type="text"
                state={produto.nome}
                setState={(value: string) => atualizarProduto(index, 'nome', value)}
                placeholder="Nome do produto"
              />

              <InputDefault
                label="Código"
                type="text"
                state={produto.codigo}
                setState={(value: string) => atualizarProduto(index, 'codigo', value)}
                placeholder="codigo-produto"
              />

              <InputDefault
                label="NCM"
                type="text"
                state={produto.ncm}
                setState={(value: string) => atualizarProduto(index, 'ncm', value)}
                placeholder="0000.00.00"
              />
            </S.FormSection>

            <S.FormSection>
              <InputDefault
                label="CEST"
                type="text"
                state={produto.cest || ''}
                setState={(value: string) => atualizarProduto(index, 'cest', value)}
                placeholder="00.000.00"
              />

              <InputDefault
                label="Quantidade"
                type="number"
                step="0.01"
                min="0"
                state={produto.quantidade.toString()}
                setState={(value: string) => atualizarProduto(index, 'quantidade', parseFloat(value) || 0)}
                placeholder="1"
              />

              <ReactSelect
                label="Unidade"
                placeholder="Unidade"
                options={unidadeOptions}
                state={produto.unidade}
                setState={(value: string) => atualizarProduto(index, 'unidade', value)}
              />
            </S.FormSection>

            <S.FormSection>
              <InputDefault
                label="Peso (kg)"
                type="number"
                step="0.001"
                min="0"
                state={produto.peso}
                setState={(value: string) => atualizarProduto(index, 'peso', value)}
                placeholder="0.000"
              />

              <InputDefault
                label="Valor Unitário"
                type="number"
                step="0.01"
                min="0"
                state={produto.subtotal}
                setState={(value: string) => atualizarProduto(index, 'subtotal', value)}
                placeholder="0.00"
              />

              <InputDefault
                label="Total"
                type="text"
                state={produto.total}
                setState={() => {}}
                placeholder="0.00"
                disabled
              />
            </S.FormSection>

            <S.FormSection>
              <InputDefault
                label="Classe de Imposto"
                type="text"
                state={produto.classe_imposto}
                setState={(value: string) => atualizarProduto(index, 'classe_imposto', value)}
                placeholder="REF17302684"
              />
            </S.FormSection>
          </S.ProductSection>
        ))}

        <Row className="mb-4 mt-4">
          <Col>
            <h4>Dados do Pedido</h4>
          </Col>
        </Row>

        <S.FormSection>
          <ReactSelect
            label="Forma de Pagamento"
            placeholder="Forma de pagamento"
            options={pagamentoOptions}
            state={pagamento}
            setState={setPagamento}
          />

          <ReactSelect
            label="Presença do Comprador"
            placeholder="Presença do comprador"
            options={presencaOptions}
            state={presenca}
            setState={setPresenca}
          />

          <ReactSelect
            label="Modalidade do Frete"
            placeholder="Modalidade do frete"
            options={modalidadeFreteOptions}
            state={modalidadeFrete}
            setState={setModalidadeFrete}
          />
        </S.FormSection>

        <S.FormSection>
          <InputDefault
            label="Frete"
            type="number"
            step="0.01"
            min="0"
            state={frete}
            setState={setFrete}
            placeholder="0.00"
          />

          <InputDefault
            label="Desconto"
            type="number"
            step="0.01"
            min="0"
            state={desconto}
            setState={setDesconto}
            placeholder="0.00"
          />

          <InputDefault
            label="Total Geral"
            type="text"
            state={total}
            setState={() => {}}
            placeholder="0.00"
            disabled
          />
        </S.FormSection>
      </S.Wrapper>

      <NfeSuccessModal
        show={showSuccessModal}
        onHide={handleCloseSuccessModal}
        nfeData={nfeResponse}
      />
    </Layout>
  );
}